var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBasket(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 25.2,
    viewBox: "0 0 28 25.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    id: "so-basket",
    d: "M28.6,11.4H26.549l-5.18-7.777a1.4,1.4,0,0,0-2.33,1.554L23.185,11.4H8.815l4.15-6.223a1.4,1.4,0,0,0-2.33-1.554L5.451,11.4H3.4a1.4,1.4,0,1,0,0,2.8H4.8V25.4a2.8,2.8,0,0,0,2.8,2.8H24.4a2.8,2.8,0,0,0,2.8-2.8V14.2h1.4a1.4,1.4,0,0,0,0-2.8ZM11.8,23.3a1.4,1.4,0,1,1-2.8,0V17.7a1.4,1.4,0,0,1,2.8,0Zm5.6,0a1.4,1.4,0,1,1-2.8,0V17.7a1.4,1.4,0,0,1,2.8,0Zm5.6,0a1.4,1.4,0,1,1-2.8,0V17.7a1.4,1.4,0,0,1,2.8,0Z",
    transform: "translate(-2 -3)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasket);
export default __webpack_public_path__ + "static/media/basket.4760ceb5e504e17bd6a061defb6c2c8e.svg";
export { ForwardRef as ReactComponent };